(function () {
  var headers = document.querySelectorAll('.oddit-header');
  if (!headers.length) return;

  Array.prototype.forEach.call(headers, function (header) {
    var mobileDrawer = header.querySelector('[data-mobile-drawer]');
    var menuTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
    var panels = header.querySelectorAll('.oddit-header__mega-menu-panel');

    // -----------------------------------------------------------------
    // Mobile menu drawer
    // -----------------------------------------------------------------

    // The drawer is fixed inset:0, which would cover the announcement bar.
    // While the drawer is open, pin the bar to the very top at its measured
    // height and start the drawer right below it — the full promo message
    // stays visible whatever the page's scroll position was.
    function positionMobileDrawer() {
      if (!mobileDrawer) return;
      var promo = document.querySelector('.oddit-announcement-bar');
      var barHeight = promo ? promo.offsetHeight : 0;
      if (promo && barHeight > 0) {
        promo.style.position = 'fixed';
        promo.style.top = '0';
        promo.style.left = '0';
        promo.style.right = '0';
        promo.style.zIndex = '1001'; // one above the drawer's 1000
        mobileDrawer.style.top = barHeight + 'px';
      } else {
        mobileDrawer.style.top = '';
      }
    }

    function releasePromoBar() {
      var promo = document.querySelector('.oddit-announcement-bar');
      if (promo) {
        promo.style.position = '';
        promo.style.top = '';
        promo.style.left = '';
        promo.style.right = '';
        promo.style.zIndex = '';
      }
    }

    function setMobileDrawer(open) {
      if (!mobileDrawer) return;
      if (open) {
        positionMobileDrawer();
      } else {
        releasePromoBar();
        mobileDrawer.style.top = '';
      }
      mobileDrawer.classList.toggle('is-open', open);
      mobileDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
      var toggle = header.querySelector('[data-mobile-menu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    var mobileMenuToggle = header.querySelector('[data-mobile-menu-toggle]');
    if (mobileMenuToggle && mobileDrawer) {
      mobileMenuToggle.addEventListener('click', function () {
        setMobileDrawer(!mobileDrawer.classList.contains('is-open'));
      });
    }

    header.querySelectorAll('[data-mobile-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMobileDrawer(false);
      });
    });

    window.addEventListener('resize', function () {
      if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
        positionMobileDrawer();
      }
    });

    // Mobile rows backed by a mega menu expand an in-drawer submenu
    // instead of navigating.
    header.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (row) {
      row.addEventListener('click', function (e) {
        var submenu = row.nextElementSibling;
        if (!submenu || !submenu.hasAttribute('data-mobile-submenu')) return;
        e.preventDefault();
        var isOpen = row.getAttribute('aria-expanded') === 'true';
        row.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        submenu.hidden = isOpen;
      });
    });

    // -----------------------------------------------------------------
    // Mega menu panels — a trigger opens the panel with the same label.
    // Hover opens/closes; click still works for keyboard and touch.
    // -----------------------------------------------------------------
    var closeTimer = null;

    function panelFor(trigger) {
      var label = trigger.getAttribute('data-mega-menu-label');
      return header.querySelector(
        '.oddit-header__mega-menu-panel[data-mega-menu-label="' + label + '"]'
      );
    }

    function closeMegaMenus() {
      Array.prototype.forEach.call(menuTriggers, function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      Array.prototype.forEach.call(panels, function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
      });
      header.classList.remove('has-mega-menu-open');
    }

    function openMegaMenu(trigger) {
      var panel = panelFor(trigger);
      if (!panel) return;
      closeMegaMenus();
      trigger.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      header.classList.add('has-mega-menu-open');
    }

    // Grace period: moving the pointer from the nav link down into the panel
    // briefly leaves both elements, which would otherwise close the menu.
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMegaMenus, 150);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    Array.prototype.forEach.call(menuTriggers, function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (trigger.getAttribute('aria-expanded') === 'true') {
          closeMegaMenus();
        } else {
          openMegaMenu(trigger);
        }
      });

      trigger.addEventListener('mouseenter', function () {
        cancelClose();
        openMegaMenu(trigger);
      });

      trigger.addEventListener('mouseleave', scheduleClose);
    });

    Array.prototype.forEach.call(panels, function (panel) {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
    });

    // Hovering any other nav link, or the overlay, closes the open panel
    header.querySelectorAll('.oddit-header__nav-link:not([data-mega-menu-trigger])').forEach(
      function (link) {
        link.addEventListener('mouseenter', closeMegaMenus);
      }
    );

    var megaOverlay = header.querySelector('[data-mega-menu-overlay]');
    if (megaOverlay) {
      megaOverlay.addEventListener('mouseenter', closeMegaMenus);
      megaOverlay.addEventListener('click', closeMegaMenus);
    }

    // Click outside the header, or Escape, closes whatever is open
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeMegaMenus();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeMegaMenus();
      setMobileDrawer(false);
    });

    // -----------------------------------------------------------------
    // Cart / search toggles
    // -----------------------------------------------------------------
    header.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMobileDrawer(false);
        if (window.OdditCartDrawer) window.OdditCartDrawer.open();
      });
    });

    header.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMobileDrawer(false);
        // toggle, not open: tapping the search icon again closes the drawer
        if (window.OdditSearchDrawer) window.OdditSearchDrawer.toggle();
      });
    });

    // Desktop search input — focusing it opens the drawer below the header
    var desktopSearchInput = header.querySelector('.oddit-header__search-input');
    if (desktopSearchInput) {
      desktopSearchInput.addEventListener('focus', function () {
        if (window.OdditSearchDrawer) window.OdditSearchDrawer.open();
      });
    }
  });

  // Cart count badge — update on cart:updated event
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].style.display = cart.item_count > 0 ? '' : 'none';
    }
  });
})();
